var $166b7c9cc1adb1a1$exports = {};
$166b7c9cc1adb1a1$exports = {
  "ascending": "artan s\u0131rada",
  "ascendingSort": function ascendingSort(args) {
    return "".concat(args.columnName, " s\xFCtuna g\xF6re artan d\xFCzende s\u0131rala");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " piksel");
  },
  "descending": "azalan s\u0131rada",
  "descendingSort": function descendingSort(args) {
    return "".concat(args.columnName, " s\xFCtuna g\xF6re azalan d\xFCzende s\u0131rala");
  },
  "resizerDescription": "Yeniden boyutland\u0131rmak i\xE7in Enter'a bas\u0131n",
  "select": "Se\xE7",
  "selectAll": "T\xFCm\xFCn\xFC Se\xE7",
  "sortable": "S\u0131ralanabilir s\xFCtun"
};
export { $166b7c9cc1adb1a1$exports as default };